import Swiper from 'swiper';
import { Autoplay, Keyboard, Mousewheel, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const swiperImages = document.getElementsByClassName('swiper-images');

if(swiperImages) {
	new Swiper('.swiper-images', {
		modules: [Autoplay, Keyboard, Mousewheel, Navigation],

		allowSlidePrev: true,
		/* autoplay: {
			delay: 3000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
			stopOnLastSlide: false,
		}, */
		grabCursor: true,
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		loop: true,
		mousewheel: true,
		navigation: {
			prevEl: '.swiper-button-prev',
			nextEl: '.swiper-button-next',
		},
		rewind: false,
		slidesOffsetAfter: 0,
		slidesOffsetBefore: 0,
		slidesPerView: 2,
		spaceBetween: 0,

		breakpoints: {
			2160: {
				slidesPerView: 6,
			},
			1728: {
				slidesPerView: 5,
			},
			1296: {
				slidesPerView: 4,
			},
			864: {
				slidesPerView: 3,
			},
		},
	});
}

const swiperLogos = document.getElementsByClassName('swiper-logos');

if(swiperLogos) {
	new Swiper('.swiper-logos', {
		modules: [Autoplay, Keyboard, Mousewheel, Navigation],

		allowSlidePrev: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
			stopOnLastSlide: false,
		},
		grabCursor: true,
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		loop: false,
		mousewheel: true,
		navigation: {
			prevEl: '.swiper-button-prev',
			nextEl: '.swiper-button-next',
		},
		rewind: false,
		slidesOffsetAfter: 48,
		slidesOffsetBefore: 48,
		slidesPerView: 'auto',
		spaceBetween: 24,

		breakpoints: {
			2160: {
				slidesOffsetAfter: 120,
				slidesOffsetBefore: 120,
				spaceBetween: 120,
			},
			984: {
				slidesOffsetAfter: 72,
				slidesOffsetBefore: 72,
				spaceBetween: 72,
			},
			576: {
				slidesOffsetAfter: 48,
				slidesOffsetBefore: 48,
				spaceBetween: 48,
			},
		},
	});
}